import * as consulApi from 'src/apis/consul';

/**
 * Load Consul properties using the API as a middleware.
 */
export const refreshConsul = () => {
    consulApi.getConsul().then(response => {
        if (response.data.result) {
            const { globalAuth, perfectMatchWeb, perfectMatchApi, perfectMatchNotifications } = response.data.result.web;
            // double check if properties exist. Don't change existing ones, otherwise.

            if (globalAuth) {
                localStorage.setItem('globalAuth', JSON.stringify(globalAuth));
            }

            if (perfectMatchWeb && perfectMatchApi) {
                localStorage.setItem('hosts', JSON.stringify({web: perfectMatchWeb, api: perfectMatchApi, notifications: perfectMatchNotifications }));
            }
        }
    }).catch(err => {
        console.error('Error while updating Consul properties.', err);
    })
}
